import { useState, useEffect } from 'react';
import { fetchGet } from '@cmd/ui-utilities';
import { getPkceFetchUrl } from '../webComponentUtils';
import pkceAuthClient from './pkceAuthClient';
import { placeholderResponses } from './placeholderData';
/**
 * Returns placeholder JSON data instead of calling the (now-sunset) backing APIs.
 * The original API-calling implementation is preserved below as dead code for reference.
 */
const useGetDataPkce = (baseUrl, resource, params, partition, transformFn) => {
    const [state, setState] = useState({
        data: null,
        isLoading: true,
        error: null,
        status: null,
    });
    useEffect(() => {
        const placeholderResponse = (placeholderResponses[resource] ?? null);
        const data = transformFn && placeholderResponse
            ? transformFn(placeholderResponse)
            : placeholderResponse;
        setState({
            data,
            isLoading: false,
            error: placeholderResponse ? null : `No placeholder data for resource: ${resource}`,
            status: placeholderResponse ? 200 : 404,
        });
    }, [params.startDate, params.endDate, params.orgId, params.limit]);
    return state;
};
export default useGetDataPkce;
// -----------------------------------------------------------------------------
// ORIGINAL IMPLEMENTATION (dead code, retained for reference)
// The backing leads-data-service and transactions-data-service APIs are sunset.
// Remove this block once the services are fully decommissioned.
// -----------------------------------------------------------------------------
// eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/naming-convention
const useGetDataPkce_ORIGINAL = (baseUrl, resource, params, partition, transformFn) => {
    const [state, setState] = useState({
        data: null,
        isLoading: true,
        error: null,
        status: null,
    });
    const { data, isLoading, error, status, } = state;
    const { startDate, endDate, orgId, limit, } = params;
    useEffect(() => {
        const fetchData = async (token) => {
            fetchGet(getPkceFetchUrl(baseUrl, partition), resource, params, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setState((prev) => ({
                    ...prev,
                    data: transformFn ? transformFn(response.data) : response.data,
                    isLoading: response.loading,
                    error: response.error,
                    status: response.status,
                }));
            }).catch((responseError) => {
                setState((prev) => ({
                    ...prev,
                    isLoading: false,
                    error: responseError,
                }));
            });
        };
        pkceAuthClient.authenticate(fetchData, (e) => {
            setState((prev) => ({
                ...prev,
                isLoading: false,
                error: e.message,
            }));
        });
    }, [
        startDate,
        endDate,
        orgId,
        limit,
    ]);
    return {
        data,
        isLoading,
        error,
        status,
    };
};
